import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/firestore';
import { UserService } from '../../services/user.service';
declare var fbq: any;
declare var window: any;

// import { ContactPage } from '../contact/contact';

@Component({
  selector: 'component-navbar',
  templateUrl: 'navbar.html',
})
export class NavbarComponent implements OnInit {

  @Input() activePage = '';
  db;
  user;
  profile: any;
  profileSub;
  @Output() userLoaded: EventEmitter<any> = new EventEmitter();
  error = '';
  settings;
  recentlyVerified = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserService,
    private titleService: Title,
  ) {
    this.userService = new UserService();
    fbq('trackSingle', '205991469998512', 'PageView');
    this.route.params.subscribe(params => {
      firebase.auth().onAuthStateChanged(async (user) => {
        this.setTitle();
        this.user = user;
        if (!user) {
          this.userLoaded.emit(null);
          return;
        } else {
          this.userLoaded.emit(user);
        }
        if (user.uid &&  params['verify'] && this.getParameterByName('oobCode')) {
          firebase.auth().applyActionCode(this.getParameterByName('oobCode')).then((resp) => {
            this.userService.verifiedUser(user.uid, true);
          }).catch(function(error) {
            // alert("Code is invalid or expired.");
          });
        } else if (user.uid && !user.emailVerified && params['verify']) {
          this.profileSub = this.userService.observeProfile(user.uid).onSnapshot((doc) => {
            this.profile = doc.data();
            if (this.profile && this.profile.isEmailVerified) {
              this.goTo('complete');
            }
          });
          return;
        } else if (user.uid && !params['verify']) {
          this.profileSub = this.userService.observeProfile(user.uid).onSnapshot((doc) => {
            this.profile = doc.data();
            if (this.profile && !this.profile.isCompleted) {
              this.goTo('complete');
            }
          });
        }
        this.settings = await this.userService.getUserSettings(user.uid);
        // this.userLoaded.emit(user);
      });
    });
    this.db = firebase.firestore();
    // this.addLink();

    // var head = document.getElementsByTagName('head')[0];
    // var script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.onload = function() {
      if (!document.getElementById('crispScript')) {
        window.$crisp=[];window.CRISP_WEBSITE_ID="b50318f6-1591-49c9-b196-1c6a3a081360";(function(){let d:any = document;let s: any = d.createElement("script");s.id="crispScript";s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
      }
    // }
    // script.src = 'path/to/your-script.js';
    // head.appendChild(script);
  }
  
  ngOnInit() {
    this.setTitle();
  }

  // addLink() {
  //   this.db.collection("links").add({
  //     first: "Alan",
  //     middle: "Mathison",
  //     last: "Turing",
  //     born: 1912
  //   })
  // }

  getParameterByName(name, url?) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  
  setTitle() {
    if (this.activePage) {
      this.titleService.setTitle('BitL.it - ' + this.activePage.charAt(0).toUpperCase() + this.activePage.slice(1));
    } else {
      this.titleService.setTitle('BitL.it | World Most Powerful Link');
    }
  }

  logout() {
    firebase.auth().signOut();
    this.goTo('login');
  }

  goTo(page) {
    switch(page) {
      case 'login':
        this.router.navigate(['/login']);
        break;
      case 'links':
        this.router.navigate(['/links']);
        break;
      case 'verify':
        this.router.navigate(['/signup/verify']);
        break;
      case 'complete':
        this.router.navigate(['/signup/complete']);
        break;
      case 'contact':
        // window.location.href = 'contact';
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/navbar/navbar.ts